const isCyAvailable = (cy) => cy && !cy.destroyed();

export const fitVisibleGraph = (cy, fitPadding) => {
  if (!isCyAvailable(cy)) return false;
  cy.fit(cy.elements(':visible'), fitPadding);
  return true;
};

export const centerVisibleGraph = (cy) => {
  if (!isCyAvailable(cy)) return false;
  cy.center(cy.elements(':visible'));
  return true;
};

export const zoomGraph = (cy, zoomStep) => {
  if (!isCyAvailable(cy)) return false;

  const nextZoom = zoomStep >= 0
    ? Math.min(cy.maxZoom(), cy.zoom() + zoomStep)
    : Math.max(cy.minZoom(), cy.zoom() + zoomStep);

  cy.zoom({
    level: nextZoom,
    renderedPosition: { x: cy.width() / 2, y: cy.height() / 2 },
  });

  return true;
};

export const panGraph = (cy, direction, panStep) => {
  if (!isCyAvailable(cy)) return false;

  if (direction === 'up') {
    cy.panBy({ x: 0, y: panStep });
    return true;
  }

  if (direction === 'down') {
    cy.panBy({ x: 0, y: -panStep });
    return true;
  }

  if (direction === 'left') {
    cy.panBy({ x: panStep, y: 0 });
    return true;
  }

  if (direction === 'right') {
    cy.panBy({ x: -panStep, y: 0 });
    return true;
  }

  return false;
};

export const getGraphKeyboardAction = (key) => {
  if (key === '+' || key === '=') return 'zoomIn';
  if (key === '-' || key === '_') return 'zoomOut';
  if (key === '0') return 'fit';
  if (key === 'c' || key === 'C') return 'center';
  if (key === 'ArrowUp') return 'panUp';
  if (key === 'ArrowDown') return 'panDown';
  if (key === 'ArrowLeft') return 'panLeft';
  if (key === 'ArrowRight') return 'panRight';
  return null;
};

export const runGraphKeyboardAction = ({
  cy,
  key,
  zoomStep,
  panStep,
  fitPadding,
}) => {
  const action = getGraphKeyboardAction(key);

  if (!action) {
    return false;
  }

  if (action === 'zoomIn') return zoomGraph(cy, zoomStep);
  if (action === 'zoomOut') return zoomGraph(cy, -zoomStep);
  if (action === 'fit') return fitVisibleGraph(cy, fitPadding);
  if (action === 'center') return centerVisibleGraph(cy);
  if (action === 'panUp') return panGraph(cy, 'up', panStep);
  if (action === 'panDown') return panGraph(cy, 'down', panStep);
  if (action === 'panLeft') return panGraph(cy, 'left', panStep);
  if (action === 'panRight') return panGraph(cy, 'right', panStep);

  return false;
};
